"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WSURI = /** @class */ (function () {
    function WSURI(decl) {
        this.scheme = decl.scheme || 'ws';
        this.host = decl.host;
        this.port = decl.port || (decl.scheme === 'wss' ? 443 : 80);
        this.path = decl.path;
        this.query = decl.query || '';
    }
    WSURI.prototype.toString = function () {
        return stringifyURI(this);
    };
    return WSURI;
}());
exports.WSURI = WSURI;
function stringifyURI(uri) {
    var portIsStandard = (uri.scheme === 'wss' && uri.port === 443) || (uri.scheme === 'ws' && uri.port === 80);
    var portFragment = portIsStandard ? '' : ':' + String(uri.port);
    var hostFragment = uri.host + portFragment;
    var schemeFragment = uri.scheme + "://";
    var pathFragment = uri.path === '' ? '/' : uri.path;
    var searchFragment = uri.query === '' ? '' : '?' + uri.query;
    return schemeFragment + hostFragment + pathFragment + searchFragment;
}
exports.stringifyURI = stringifyURI;
function normalizeURI(decl) {
    return new WSURI(decl);
}
exports.normalizeURI = normalizeURI;
function parseURI(uri) {
    var parsedUri = uri;
    var schemePattern = /^[a-z0-9.+-]+:/i;
    var portPattern = /:[0-9]*$/;
    var hostAndPortPattern = /^\/\/([^:/\\?#]*)(?::([^/\\?#]*))?/;
    var pathPattern = /^\/([a-z0-9_-]+\/)+/;
    var schemeMatches = parsedUri.match(schemePattern);
    if (!schemeMatches) {
        console.error('Invalid uri, scheme not found');
        return null;
    }
    // Delete ":"
    var scheme = schemeMatches[0].slice(0, -1);
    parsedUri = parsedUri.slice(schemeMatches[0].length);
    var hostMatches = parsedUri.match(hostAndPortPattern);
    if (!hostMatches) {
        console.error('Invalid uri, host not found');
        return null;
    }
    var host = hostMatches[1];
    var port;
    if (hostMatches[0].search(portPattern) !== -1) {
        port = Number(hostMatches[2]);
    }
    parsedUri = parsedUri.slice(hostMatches[0].length);
    var pathMatches = parsedUri.match(pathPattern);
    var path = pathMatches ? pathMatches[0] : '';
    if (pathMatches) {
        parsedUri = parsedUri.slice(pathMatches[0].length);
    }
    var query = parsedUri.length ? parsedUri.slice(1) : '';
    return {
        host: host,
        path: path,
        port: port,
        scheme: scheme,
        query: query,
    };
}
exports.parseURI = parseURI;
//# sourceMappingURL=uri.js.map